// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"ErrorMessage_errorMessage__Z5G_P","icon":"ErrorMessage_icon__w_sFC","subMessage":"ErrorMessage_subMessage__KMKy7"};